import ltcOptions from '../content/MenLikeMe/ltcOptions.json';
import contentData from '../content/MenLikeMe/inputs.json';

export const inputsDataParser = (inputs, currentInputGroup) => {
  if (!inputs) {
    return null;
  }
  const requiredInputs = inputs;

  return requiredInputs.map((input) => {
    let inputParsedOptions;
    if (input.inputType === 'multipleSelect') {
      inputParsedOptions = ltcOptions.map((option) => {
        return {
          itemKey: option.position,
          text: option.value
        };
      });
    } else {
      inputParsedOptions = input.options.map((option) => {
        const parsedSubOptions =
          option.subOptions &&
          option.subOptions.map((subOption) => {
            return {
              itemKey: subOption.id,
              text: subOption.value,
              categoryId: subOption.categoryId,
              name: 'trt'
            };
          });

        return {
          itemKey: option.position,
          text: option.value,
          subOptionsQuestion: option.subOptionsQuestion,
          subOptions: parsedSubOptions
        };
      });
    }

    const content = contentData.find((inputContent) => inputContent.name === input.name);
    const existingInputGroup = currentInputGroup.find((inputGroup) => inputGroup.name === input.name);
    const selectedValue = existingInputGroup && existingInputGroup.selectedValue;

    return {
      ...input,
      selectedValue,
      question: inputParsedOptions.subOptionsQuestion || content.question,
      info: content ? content.info : '',
      options: inputParsedOptions
    };
  });
};
